import { QueryClient } from '@tanstack/react-query';
import { QUERY_CLIENT_DEFAULTS } from '../sic-lib/defaults';

export const queryClient = new QueryClient(QUERY_CLIENT_DEFAULTS);
